module.exports = __webpack_public_path__ + "img/SATLOGO.41726627.png";